export default {
    lastUpdated: "Last updated",
    footer: {
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
    },
    terms: {
        title: "Terms & Conditions",
        sections: {
            acceptance: {
                title: "1. Acceptance of terms",
                content:
                    "By accessing or using the Eve Mind platform, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, you may not use our services.",
            },
            useOfService: {
                title: "2. Use of the service",
                content:
                    "Eve Mind provides a trade and logistics management platform. You agree to use the service only for lawful purposes and in accordance with these terms. You are responsible for maintaining the confidentiality of your account credentials.",
            },
            accountSecurity: {
                title: "3. Account and security",
                content:
                    "You must provide accurate and complete information when creating an account. You are responsible for all activity that occurs under your account. Notify us immediately of any unauthorized use.",
            },
            intellectualProperty: {
                title: "4. Intellectual property",
                content:
                    "All content, features, and functionality of the Eve Mind platform are owned by Eve Mind and are protected by international copyright, trademark, and other intellectual property laws.",
            },
            limitationOfLiability: {
                title: "5. Limitation of liability",
                content:
                    "To the maximum extent permitted by law, Eve Mind shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the service.",
            },
            changes: {
                title: "6. Changes to terms",
                content:
                    "We may modify these terms at any time. We will notify you of material changes by posting the updated terms on this page and updating the \"Last updated\" date. Your continued use of the service after such changes constitutes acceptance.",
            },
            contact: {
                title: "7. Contact",
                content:
                    "For questions about these Terms & Conditions, please contact us at eve.mind.ai@gmail.com.",
            },
        },
    },
    privacy: {
        title: "Privacy Policy",
        sections: {
            dataWeCollect: {
                title: "1. Data we collect",
                content:
                    "We collect information you provide directly (e.g. account details, company information), data generated through your use of the platform (e.g. shipment and document data), and technical data (e.g. IP address, browser type) necessary for the operation of the service.",
            },
            howWeUse: {
                title: "2. How we use data",
                content:
                    "We use your data to provide, maintain, and improve the Eve Mind platform, to process your requests, to communicate with you, and to comply with legal obligations. We do not sell your personal data to third parties.",
            },
            dataSharing: {
                title: "3. Data sharing",
                content:
                    "We may share data with service providers who assist in operating our platform (e.g. hosting, analytics), with your consent, or when required by law. We require such providers to protect your data appropriately.",
            },
            retention: {
                title: "4. Retention",
                content:
                    "We retain your data for as long as your account is active or as needed to provide you services. We may retain certain data for longer where required by law or for legitimate business purposes.",
            },
            yourRights: {
                title: "5. Your rights",
                content:
                    "Depending on your jurisdiction, you may have the right to access, correct, delete, or port your personal data, or to object to or restrict certain processing. Contact us at eve.mind.ai@gmail.com to exercise these rights.",
            },
            cookies: {
                title: "6. Cookies and similar technologies",
                content:
                    "We use cookies and similar technologies to maintain sessions, remember preferences, and analyze usage. You can control cookie settings through your browser.",
            },
            contact: {
                title: "7. Contact",
                content:
                    "For questions about this Privacy Policy or our data practices, please contact us at eve.mind.ai@gmail.com.",
            },
        },
    },
};
